import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { HisNavigationService } from '../../core/service/base/his-navigation.service';
import { HisSearchPrintviewData } from '../model/printview/his-search-printview-data';

@Component( {
    selector: 'his-search-printview',
    templateUrl: './his-search-printview.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchPrintviewComponent {
    private navigationService = inject(HisNavigationService);
    private router = inject(Router);


    printViewData: HisSearchPrintviewData;

    constructor() {
        this.router.events.pipe(
            filter( event => event instanceof NavigationEnd )
        ).subscribe( () => {
            const navigation = this.router.currentNavigation();
            if ( navigation && navigation.extras.state ) {
                this.printViewData = navigation.extras.state.data;
            } else {
                // Handle when data is not passed
            }
        } );
    }

    backToSearchResult() {
        this.navigationService.navigateToLastSearchResultUrl();
    }

    printPage() {
        window.print();
    }
}